import * as yup from 'yup'

export class VehicleCheckInTirePressureLabelPhotoDto {
  documentGuid?: string = undefined
  displayFileName?: string = undefined
    vehicleCheckInTirePressureLabelPhotoFile?: File = undefined
  vehicleCheckInIsTirePressureLabelPhotoMissing?: boolean = undefined
  vehicleCheckInTirePressureLabelMissingNote?: string = undefined
}

export const vehicleCheckInTirePressureLabelPhotoValidationSchema = yup.object({
  vehicleCheckInTirePressureLabelPhotoFile: yup.mixed().nullable(),
  vehicleCheckInIsTirePressureLabelPhotoMissing: yup.boolean().nullable(),
  vehicleCheckInTirePressureLabelMissingNote: yup
    .string()
    .nullable()
    .when('vehicleCheckInIsTirePressureLabelPhotoMissing', {
      is: true,
      then: schema =>
        schema
          .max(200, 'Tire Pressure Label Missing Note cannot be more than 200 characters.')
          .required('Tire Pressure Label Missing Note is required when Tire Pressure Label is missing.')
    })
})
